// component instance
export default {
  props: ['payload'],
  components: {},
  data: function () {
    return {
      title: this.payload
        ? this.payload.title ||
        this.payload.fields.title ||
        this.payload.head ||
        this.payload.fields.head ||
        this.payload.header ||
        this.payload.fields.header : null,
      desc: this.payload
        ? this.payload.fields.body ||
        this.payload.body ||
        this.payload.desc ||
        this.payload.fields.desc ||
        this.payload.description ||
        this.payload.fields.description ||
        this.payload.text ||
        this.payload.fields.text
        : null,
      image: this.payload ? this.payload.fields.image || this.payload.image : null
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
}



// WEBPACK FOOTER //
// ./src/components/textblockBase.js